import {
    container,
    defaultFont,
    minHeight,
    appbarHeight,
    drawerWidth
} from "./../psacount";
const dialogStyle = (theme) => ({
    appBar: {
        ...defaultFont,
        // [theme.breakpoints.down("md")]: {
        //     // width: `calc(100% - ${drawerWidth}px)`
        //     width: `calc(100%)`
        // },
        // #546e7a
        position: 'relative',
        backgroundColor: "#546e7a !important",
        borderBottom: "0",
        marginBottom: "0",
        // width: `calc(100% - ${drawerWidth}px)`, 
    },
    title: {
        ...defaultFont,
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    container: {
        ...container
    }

});

export default dialogStyle;
